// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"b63cda32","158":"b61cb4cc","217":"1594f327","398":"36b54733","453":"7fdbb12c","785":"903e7eb1","929":"ac772790"}[chunkId] + ".chunk.js";
};